import { render } from "./PostpaidQA.vue?vue&type=template&id=02807798&scoped=true"
import script from "./PostpaidQA.vue?vue&type=script&lang=js"
export * from "./PostpaidQA.vue?vue&type=script&lang=js"

import "./PostpaidQA.vue?vue&type=style&index=0&id=02807798&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02807798"

export default script